const reviewedStatuses = ["approved", "rejected"];

export default status => reviewedStatuses.includes(status);
